import '../../styles/restScreens.css';
import React from 'react';
import TaskCard from './TaskCard';

// ============================================================
// BucketGroupedCards — card/swim-lane view, grouped by bucket_name.
// Tasks with no bucket_name fall into an "Unassigned" lane.
// ============================================================

export default function BucketGroupedCards({ tasks, theme = 'light', onSelectTask }) {
  const buckets = {};
  tasks.forEach(t => {
    const key = t.bucket_name || 'Unassigned';
    if (!buckets[key]) buckets[key] = [];
    buckets[key].push(t);
  });

  const bucketNames = Object.keys(buckets).sort((a, b) => {
    if (a === 'Unassigned') return 1;
    if (b === 'Unassigned') return -1;
    return a.localeCompare(b);
  });

  if (bucketNames.length === 0) {
    return (
      <div data-m6-layout="tasks" data-m6-component="BucketGroupedCards" className={`text-center py-12 text-sm ${theme === 'dark' ? 'text-gray-400' : 'text-gray-500'}`}>
        No tasks match the current filters.
      </div>
    );
  }

  return (
    <div data-m6-layout="tasks" data-m6-component="BucketGroupedCards" className="flex gap-4 overflow-x-auto pb-4">
      {bucketNames.map(bucket => (
        <div key={bucket} className="w-72 shrink-0">
          <div className={`flex items-center justify-between mb-2 px-1`}>
            <h3 className={`text-sm font-semibold ${theme === 'dark' ? 'text-gray-200' : 'text-gray-700'}`}>{bucket}</h3>
            <span className={`text-xs ${theme === 'dark' ? 'text-gray-500' : 'text-gray-400'}`}>{buckets[bucket].length}</span>
          </div>
          <div className="space-y-2">
            {buckets[bucket].map(task => (
              <TaskCard key={task.id} task={task} theme={theme} onClick={() => onSelectTask(task)} />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
